import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=74e95b88&scoped=true"
import script from "./MainDialog.vue?vue&type=script&lang=js"
export * from "./MainDialog.vue?vue&type=script&lang=js"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=74e95b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e95b88",
  null
  
)

export default component.exports